<template>
  <div>
    <!-- 聊天对象 -->
    <div class="header">
        <h3>{{list[0].name}}</h3>
    </div>
    <!-- 聊天内容 -->
    <div class="mine">
        <!-- 这里的内容需要v-for循环写入里面的
        1、把每一个人说的话都单独放在一个数组里面
        2、定义一个另外的数据，来跟输入的内容进行数据双向绑定
        3、点击按钮，将数据push到保存说的话的数组当中
        4、输出：有两个样式
            自己输出的在右面
            对方输出的在左面 -->
        <div class="talkShow">
            <div v-for="(item,index) in list" :key="index">
                <span>{{item.content}}</span>
            </div>
        </div>
        <!-- 发送消息 -->
        <div class="sendBox">
            <!-- 首先一个输入框 -->
            <input type="text" v-model="wordone" class="inputword" @keyup.enter="sendMsg1()">
            <input type="button" value="发送" class="btnsend" @click="sendMsg2()">
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            list:[
                {
                    id:1,
                    name:'小温同学',
                    content:'早上好！'
                },
                {
                    id:2,
                    name:'小wu同学',
                    content:'早上好！'
                },
            ],
            wordone:'',
            wordtwo:''
        }
    },
    methods:{
        sendMsg1(){
            this.list.push({
                id:1,name:'小ww',content:this.wordone
            })
            this.wordtwo=''
        },
        sendMsg2(){
             this.list.push({
                id:2,name:'小tt',content:this.wordtwo
            })
        }
    }
}
</script>

<style>

</style>